export default class AddOnItemFunctions {
    
    static chooseAddOnItem(addOnItemID, qty, price) {
        let old = this.state;
        old.choices.addOns[addOnItemID] = {quantity: qty, price: price};
        this.setState(old);
    }

    static increaseAddOnQuantity(addOnItemID) {
        let old = this.state;
        let oldQuantity = old.choices.addOns[addOnItemID].quantity;
        let oldPrice = old.choices.addOns[addOnItemID].price;
        old.choices.addOns[addOnItemID] = {quantity: oldQuantity + 1, price: oldPrice};
        this.setState(old);
    }

    static decreaseAddOnQuantity(addOnItemID) {
        let old = this.state;
        let oldQuantity = old.choices.addOns[addOnItemID].quantity;
        let oldPrice = old.choices.addOns[addOnItemID].price;
        old.choices.addOns[addOnItemID] = {quantity: oldQuantity - 1, price: oldPrice};
        this.setState(old);
    }

    static removeAddOnItem(addOnItemID) {
        if(this.state.choices.addOns[addOnItemID]) {
            let old = this.state;
            delete old.choices.addOns[addOnItemID];
            this.setState(old);
        }
    }
}